<template>
    <div class="product-configurator-inline">
        <transition name="screen-transition" mode="out-in">
            <div v-if="showScreenIntro && dataReady" key="screenIntro" :class="['screen', 'screen-intro', {'reverted': revertTransition}]">
                <product-showcase :inView="inView" :desktopMode="desktopMode"></product-showcase>
                <product-description @clickContinueIntro="continuTo('selection')"></product-description>
            </div>

            <div v-if="showScreenSelection" key="screenSelection" :class="['screen', 'screen-selection', {'reverted': revertTransition}]">
                <product-slider
                    :desktopMode="desktopMode"
                    @selectPart="onPartSelection"
                    @clickContinuSelection="continuTo('fragrance')">
                </product-slider>
            </div>

            <div v-if="showScreenFragrance" key="screenFragrance" :class="['screen', 'screen-fragrance', {'reverted': revertTransition}]">
                <selected-product
                    :desktopMode="desktopMode"
                    :partName="selectedPartName"
                    :productImage="selectedPartImage"
                    :fragranceName="selectedFragranceName"
                    @clickReturnSelectedProduct="returnTo('selection')">
                </selected-product>
                <fragrance-slider
                    :desktopMode="desktopMode"
                    @selectFragrance="onFragranceSelection"
                    @clickReturnSelectedProduct="returnTo('selection')"
                    @clickContinuFragranceSlider="continuTo('result')">
                </fragrance-slider>
            </div>

            <div v-if="showScreenResult" key="screenResult" :class="['screen', 'screen-result', {'reverted': revertTransition}]">
                <result-slider :mobileMode="mobileMode" @clickReturnResultSlider="returnTo('selection')"></result-slider>
                <product-description :hideParagraph="mobileMode" :isResultScreen="true"></product-description>
            </div>
        </transition>
    </div>
</template>

<script src="./product-configurator-inline.js"></script>
